<template>
  <NuxtLink
    :to="removeCmsDomain(path)"
    class="relative z-50 inline-block rounded-full px-4 py-2 text-center font-serif text-lg font-normal uppercase leading-tight text-white"
    :class="[pink ? 'bg-pink' : 'bg-blue']"
  >
    <slot></slot>
  </NuxtLink>
</template>

<script setup lang="ts">
import { removeCmsDomain } from '../../utils/urlFilter'

defineProps({
  pink: { type: Boolean, default: false },
  path: String,
})
</script>
